type PlaybookGuidanceProps = {
  copy?: string
  topic: string
}

export function PlaybookGuidance({ copy, topic }: PlaybookGuidanceProps) {
  if (!copy) {
    return null
  }

  return (
    <aside
      aria-label={`${topic} playbook guidance`}
      className="rounded-[4px] border border-[#b8ccf2] bg-[#f3f7ff] px-3 py-2.5"
    >
      <p className="text-[11px] font-semibold uppercase leading-4 tracking-[0.66px] text-[#86a0d1]">
        Playbook guidance
      </p>
      <p className="mt-1 whitespace-pre-line text-xs font-normal leading-4 text-black">{copy}</p>
    </aside>
  )
}
